// import React, { useState, useEffect } from "react";
// import { Icon } from "@iconify/react";
// import Swal from "sweetalert2";
// import "../warehousedetails/wareHouseDetails.scss";
// import { fetchData } from "../helper/api.interceptor";
// import Select from "react-select";

// // Import your static data
// import indiaLocations from "../data/indiaLocations.json";

// const AddWareHouseDetails = ({ show, onClose, onProviderAdded }) => {
//     const [form, setForm] = useState({
//         warehouse_name: "",
//         warehouse_id: "",
//         state: "",
//         district: "",
//         city: "",
//         pincode: "",
//     });
//     const [districts, setDistricts] = useState([]);
//     const [cities, setCities] = useState([]);
//     const [loading, setLoading] = useState(false);

//     // Update districts when state changes
//     useEffect(() => {
//         if (form.state) {
//             const stateObj = indiaLocations.find((s) => s.state === form.state);
//             setDistricts(stateObj?.districts || []);
//         } else {
//             setDistricts([]);
//         }
//         setForm((prev) => ({ ...prev, district: "", city: "" }));
//         setCities([]);
//     }, [form.state]);

//     // Update cities when district changes (flatten villages)
//     useEffect(() => {
//         const districtObj = districts.find((d) => d.district === form.district);

//         if (districtObj?.subDistricts) {
//             const allVillages = districtObj.subDistricts.flatMap(
//                 (sd) => sd.villages || []
//             );
//             setCities(allVillages);
//         } else {
//             setCities([]);
//         }

//         setForm((prev) => ({ ...prev, city: "" }));
//     }, [form.district, districts]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setForm((prev) => ({ ...prev, [name]: value }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const { warehouse_name, warehouse_id, state, district, city, pincode } = form;

//         if (!warehouse_name || !warehouse_id || !state || !district || !city || !pincode) {
//             return Swal.fire("Missing Fields", "Please fill out all fields", "warning");
//         }

//         setLoading(true);
//         try {
//             const response = await fetchData.post("/add-warehouse", form);
//             if (response?.status_code === 200) {
//                 Swal.fire("Success", "Warehouse added successfully", "success");
//                 onProviderAdded();
//                 resetForm();
//                 onClose();
//             } else {
//                 throw new Error(response?.message || "Failed to add warehouse");
//             }
//         } catch (error) {
//             Swal.fire("Error", error.message, "error");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const resetForm = () => {
//         setForm({
//             warehouse_name: "",
//             warehouse_id: "",
//             state: "",
//             district: "",
//             city: "",
//             pincode: "",
//         });
//         setDistricts([]);
//         setCities([]);
//     };

//     if (!show) return null;

//     return (
//         <div className="modal-backdrop">
//             <div className="modal-container">
//                 <div className="modal-content">
//                     {/* Modal header */}
//                     <div className="modal-header">
//                         <h5 className="modal-title">Add Warehouse Details</h5>
//                         <button type="button" className="close-btn" onClick={onClose}>
//                             <Icon icon="mdi:close" />
//                         </button>
//                     </div>

//                     {/* Modal body */}
//                     <div className="modal-body">
//                         <form onSubmit={handleSubmit}>
//                             {/* Warehouse name */}
//                             <div className="form-group">
//                                 <label>Warehouse Name</label>
//                                 <input
//                                     type="text"
//                                     name="warehouse_name"
//                                     value={form.warehouse_name}
//                                     onChange={handleChange}
//                                     className="form-control"
//                                 />
//                             </div>

//                             {/* Warehouse ID */}
//                             <div className="form-group">
//                                 <label>Warehouse ID</label>
//                                 <input
//                                     type="text"
//                                     name="warehouse_id"
//                                     value={form.warehouse_id}
//                                     onChange={handleChange}
//                                     className="form-control"
//                                 />
//                             </div>

//                             {/* State */}
//                             <div className="form-group">
//                                 <label>State</label>
//                                 <Select
//                                     options={indiaLocations.map((s) => ({
//                                         label: s.state,
//                                         value: s.state,
//                                     }))}
//                                     value={form.state ? { label: form.state, value: form.state } : null}
//                                     onChange={(selected) =>
//                                         setForm((prev) => ({ ...prev, state: selected?.value || "", district: "", city: "" }))
//                                     }
//                                     placeholder="Search & Select State"
//                                     isClearable
//                                 />
//                             </div>

//                             {/* District */}
//                             <div className="form-group">
//                                 <label>District</label>
//                                 <Select
//                                     options={districts.map((d) => ({
//                                         label: d.district,
//                                         value: d.district,
//                                     }))}
//                                     value={form.district ? { label: form.district, value: form.district } : null}
//                                     onChange={(selected) =>
//                                         setForm((prev) => ({ ...prev, district: selected?.value || "", city: "" }))
//                                     }
//                                     placeholder="Search & Select District"
//                                     isDisabled={!districts.length}
//                                     isClearable
//                                 />
//                             </div>

//                             {/* City */}
//                             <div className="form-group">
//                                 <label>City & Village</label>
//                                 <Select
//                                     options={cities.map((c) => ({ label: c, value: c }))}
//                                     value={form.city ? { label: form.city, value: form.city } : null}
//                                     onChange={(selected) =>
//                                         setForm((prev) => ({ ...prev, city: selected?.value || "" }))
//                                     }
//                                     placeholder="Search & Select City"
//                                     isDisabled={!cities.length}
//                                     isClearable
//                                 />
//                             </div>


//                             {/* Pincode */}
//                             <div className="form-group">
//                                 <label>Pincode</label>
//                                 <input
//                                     type="text"
//                                     name="pincode"
//                                     value={form.pincode}
//                                     onChange={handleChange}
//                                     className="form-control"
//                                 />
//                             </div>

//                             {/* Footer */}
//                             <div className="modal-footer">
//                                 <button
//                                     type="button"
//                                     className="btn btn-secondary"
//                                     onClick={onClose}
//                                 >
//                                     Close
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="btn btn-primary"
//                                     disabled={loading}
//                                 >
//                                     {loading ? (
//                                         <>
//                                             <Icon icon="eos-icons:loading" className="spinner" />
//                                             Adding...
//                                         </>
//                                     ) : (
//                                         "Add Warehouse"
//                                     )}
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AddWareHouseDetails;
import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import "../warehousedetails/wareHouseDetails.scss";
import { fetchData } from "../helper/api.interceptor";
import Select from "react-select";

// Import your static data
import indiaLocations from "../data/indiaLocations.json";

const AddWareHouseDetails = ({ show, onClose, onProviderAdded }) => {
    const [form, setForm] = useState({
        warehouse_name: "",
        warehouse_id: "",
        state: "",
        cities: [], // Changed to array for multi-select
        pincode: "",
    });
    const [availableCities, setAvailableCities] = useState([]);
    const [loading, setLoading] = useState(false);

    // Update available cities when state changes (using districts as cities)
    useEffect(() => {
        if (form.state) {
            const stateObj = indiaLocations.find((s) => s.state === form.state);
            // Use districts as cities
            const districtList = stateObj?.districts?.map(d => d.district) || [];
            setAvailableCities(districtList);
        } else {
            setAvailableCities([]);
        }
        // Reset cities when state changes
        setForm((prev) => ({ ...prev, cities: [] }));
    }, [form.state]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { warehouse_name, warehouse_id, state, cities, pincode } = form;

        if (!warehouse_name || !warehouse_id || !state || !cities.length) {
            return Swal.fire("Missing Fields", "Please fill out all fields", "warning");
        }

        setLoading(true);
        try {
            // Prepare the payload exactly as backend expects
            const payload = {
                warehouse_name,
                warehouse_id,
                state,
                cities: cities.map(city => city.value), // Extract string values from selected options
                pincode
            };

            console.log("Sending payload:", payload); // Debug log

            const response = await fetchData.post("/add-warehouse", payload);

            if (response?.status_code === 200) {
                Swal.fire("Success", "Warehouse added successfully", "success");
                onProviderAdded();
                resetForm();
                onClose();
            } else {
                throw new Error(response?.message || "Failed to add warehouse");
            }
        } catch (error) {
            console.error("Error adding warehouse:", error);
            Swal.fire("Error", error.message, "error");
        } finally {
            setLoading(false);
        }
    };

    const resetForm = () => {
        setForm({
            warehouse_name: "",
            warehouse_id: "",
            state: "",
            cities: [],
            pincode: "",
        });
        setAvailableCities([]);
    };

    if (!show) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-container">
                <div className="modal-content">
                    {/* Modal header */}
                    <div className="modal-header">
                        <h5 className="modal-title">Add Warehouse Details</h5>
                        <button type="button" className="close-btn" onClick={onClose}>
                            <Icon icon="mdi:close" />
                        </button>
                    </div>

                    {/* Modal body */}
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            {/* Warehouse name */}
                            <div className="form-group">
                                <label>Warehouse Name *</label>
                                <input
                                    type="text"
                                    name="warehouse_name"
                                    value={form.warehouse_name}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>

                            {/* Warehouse ID */}
                            <div className="form-group">
                                <label>Warehouse ID *</label>
                                <input
                                    type="text"
                                    name="warehouse_id"
                                    value={form.warehouse_id}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>

                            {/* State */}
                            <div className="form-group">
                                <label>State *</label>
                                <Select
                                    options={indiaLocations.map((s) => ({
                                        label: s.state,
                                        value: s.state,
                                    }))}
                                    value={form.state ? { label: form.state, value: form.state } : null}
                                    onChange={(selected) =>
                                        setForm((prev) => ({
                                            ...prev,
                                            state: selected?.value || "",
                                            cities: []
                                        }))
                                    }
                                    placeholder="Search & Select State"
                                    isClearable
                                    required
                                />
                            </div>

                            {/* Cities (multi-select using districts as cities) */}
                            <div className="form-group">
                                <label>Cities *</label>
                                <Select
                                    isMulti
                                    options={availableCities.map((city) => ({
                                        label: city,
                                        value: city,
                                    }))}
                                    value={form.cities}
                                    onChange={(selected) =>
                                        setForm((prev) => ({
                                            ...prev,
                                            cities: selected || [],
                                        }))
                                    }
                                    placeholder={
                                        form.state ? "Select one or more cities" : "Please select state first"
                                    }
                                    isDisabled={!availableCities.length}
                                    required
                                />
                            </div>

                            {/* Pincode
                            <div className="form-group">
                                <label>Pincode *</label>
                                <input
                                    type="text"
                                    name="pincode"
                                    value={form.pincode}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div> */}

                            {/* Footer */}
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={onClose}
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <Icon icon="eos-icons:loading" className="spinner" />
                                            Adding...
                                        </>
                                    ) : (
                                        "Add Warehouse"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddWareHouseDetails;